import { CheckboxProps, SxProps } from "@mui/material";
import { Control, Controller } from "react-hook-form";
import CustomizedCheckbox from "../Custom/CustomizedCheckbox";
import { ReactNode } from "react";

type Props = {
  sx?: SxProps;
  label?: ReactNode;
  error?: boolean;
  testId?: string;
  control: Control<any>;
  name: string;
  disabled?: boolean;
  onChange?: CheckboxProps["onChange"];
  customIcon?: ReactNode;
};

const ControlledCheckbox = ({
  control,
  name,
  label,
  disabled,
  sx,
  onChange,
  customIcon,
}: Props) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <CustomizedCheckbox
          {...field}
          sx={sx}
          label={label}
          isDisabled={disabled}
          onChange={(e) => {
            field.onChange(e);
            if (onChange) {
              onChange(e, e.target.checked);
            }
          }}
          customIcon={customIcon}
        />
      )}
    />
  );
};

export default ControlledCheckbox;
